import { buildUrl } from "./base";
import { withCsrfHeaders } from "./csrf";
// Delete only akaun (not nama)
export async function apiDeleteAkaunPenyewa(id) {
  try {
  const response = await fetch(buildUrl(`/penyewa/akaun/${id}`), {
      method: "DELETE",
      headers: await withCsrfHeaders({
        "Content-Type": "application/json",
      }),
    });
    if (!response.ok) {
      let errorMsg = "Ralat rangkaian atau pelayan.";
      try {
        const errData = await response.json();
        errorMsg = errData.message || errorMsg;
      } catch {}
      return { error: true, message: errorMsg };
    }
    return await response.json();
  } catch (err) {
    return { error: true, message: "Ralat rangkaian atau pelayan." };
  }
}

// Update akaun and nama records together (for EditPenyewa)
export async function apiUpdatePenyewa(id, saveData) {
  try {
  const response = await fetch(buildUrl(`/penyewa/${id}`), {
      method: "PUT",
      headers: await withCsrfHeaders({
        "Content-Type": "application/json",
        ...(saveData.bahagian_pemantau
          ? { "x-bahagian-pemantau": saveData.bahagian_pemantau }
          : {}),
      }),
      body: JSON.stringify(saveData),
    });
    if (!response.ok) {
      let errorMsg = "Ralat rangkaian atau pelayan.";
      try {
        const errData = await response.json();
        errorMsg = errData.message || errorMsg;
      } catch {}
      return { error: true, message: errorMsg };
    }
    return await response.json();
  } catch (err) {
    return { error: true, message: "Ralat rangkaian atau pelayan." };
  }
}
export async function apiTambahPenyewa(data) {
  try {
  const response = await fetch(buildUrl("/penyewa"), {
      method: "POST",
      headers: await withCsrfHeaders({
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      // Try to parse error message from backend
      let errorMsg = "Ralat rangkaian atau pelayan.";
      try {
        const errData = await response.json();
        errorMsg = errData.message || errorMsg;
      } catch {}
      return { error: true, message: errorMsg };
    }
    return await response.json();
  } catch (err) {
    return { error: true, message: "Ralat rangkaian atau pelayan." };
  }
}

export async function apiDeletePenyewa(id) {
  try {
  const response = await fetch(buildUrl(`/penyewa/${id}`), {
      method: "DELETE",
      headers: await withCsrfHeaders({
        "Content-Type": "application/json",
      }),
    });
    if (!response.ok) {
      let errorMsg = "Ralat rangkaian atau pelayan.";
      try {
        const errData = await response.json();
        errorMsg = errData.message || errorMsg;
      } catch {}
      return { error: true, message: errorMsg };
    }
    // Always expect JSON response from backend
    return await response.json();
  } catch (err) {
    return { error: true, message: "Ralat rangkaian atau pelayan." };
  }
}
